<template>
  <div class="form-button">
    <button class="Button" :class="[btnType, isActive ? effectClass : '']" v-on:click="clickEvent">
      {{ btnName }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    btnType: String,
    btnName: String,
    isActive: Boolean,
  },
  data() {
    return {
      effectClass: 'effect',
    };
  },
  methods: {
    clickEvent() {
      this.$emit('parentCall');
    },
  },
};
</script>

<style lang="scss" src="../scss/form-button.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/FormButton.vue